export const environment = {
  appName: 'Handyhand',
  appUrl: 'http//localhost:4000',
  country: 'Denmark',
  platformUrl: 'http://localhost:4200',
  production: false,
  supportEmail: 'support@handyhand.dk',
  supportPhone: '+45 93833441',
  env: 'local',
  apiUrl: 'http://localhost:3000/api',
  apiV2Url: 'http://localhost:1234',
  vectorServiceUrl: 'http://localhost:3001/api',
  googleTagId: 'GTM-',
  dashboardBaseRef: 'http://localhost:9000/',
  apiPrefix: '',
  resizeUrl: 'https://d3r2zfg0xujt92.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'http://localhost:4000',
  posthog: {
    key: 'phc_CclftH2vXTL1AqhE3n7mxqYmPdHSHEcWdReQLIIOrMi',
    host: 'https://i.handyhand.dk',
  },
  social: {
    fb: 'https://da-dk.facebook.com/ahandyhand',
    instagram: 'https://www.instagram.com/handyhand.dk/',
    linkedin: 'https://dk.linkedin.com/company/handy-hand',
  },
};
